import { Component, Inject, OnInit } from '@angular/core';
import { IscFormModalData } from '@intersystems/isc-form';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormButton, FDN, VALIDATORS } from '@intersystems/isc-form';
@Component({
  selector: 'app-icca-external-object-storage-dialog',
  templateUrl: './external-object-storage-dialog.component.html',
  styleUrls: ['./external-object-storage-dialog.component.scss'],
})
export class IccaExternalObjectStorageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IccaExternalObjectStorageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IscFormModalData,
  ) {}
}
